import http from "../plugins/axios"

export const getAnnouncementList = async (params) => {
  try {
    const response = await http.get(`/announcements`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}